import * as React from 'react';

function SvgCw(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M24.03 2v7a1.05 1.05 0 01-.28.7 1 1 0 01-.72.3h-7a.9.9 0 01-.9-.64.85.85 0 01.2-1.06l2.16-2.16A7.73 7.73 0 0012.03 4a7.65 7.65 0 00-3.1.64A7.94 7.94 0 004.65 8.9a7.83 7.83 0 000 6.2 7.94 7.94 0 004.26 4.26 7.65 7.65 0 003.12.64 7.94 7.94 0 006.3-3.1.47.47 0 01.37-.2.6.6 0 01.39.14L21.2 19a.5.5 0 01.17.31.44.44 0 01-.14.36 11.3 11.3 0 01-4.12 3.19A12.33 12.33 0 0112.03 24a11.89 11.89 0 01-4.67-.95 11.43 11.43 0 01-3.83-2.57 13.69 13.69 0 01-2.58-3.84A10.44 10.44 0 01.03 12a13.25 13.25 0 011-4.64 11.11 11.11 0 012.5-3.84A13.32 13.32 0 017.34 1a11.37 11.37 0 014.69-1 11.62 11.62 0 014.43.87 12.43 12.43 0 013.83 2.46l2-2a.88.88 0 011.09-.22.93.93 0 01.65.89z" />
    </svg>
  );
}

const MemoSvgCw = React.memo(SvgCw);
export default MemoSvgCw;
